class Print {
  constructor() {
    Object.assign(this, {
      iframeEl: null,
    });
    this.setupPrintFrame();
  }

  setupPrintFrame() {
    if (!this.iframeEl) {
      this.iframeEl = document.createElement("iframe");
      this.iframeEl.onload = () => {
        if (this.iframeEl.src) {
          this.iframeEl.contentWindow.focus();
          this.iframeEl.contentWindow.print();
        }
      };
      this.iframeEl.id = "PrintFrame";
      this.iframeEl.style.position = "fixed";
      this.iframeEl.style.right = "0";
      this.iframeEl.style.bottom = "0";
      this.iframeEl.style.width = "0";
      this.iframeEl.style.height = "0";
      this.iframeEl.style.border = "0";
      this.iframeEl.style.display = "none";
      document.body.appendChild(this.iframeEl);
    }
  }

  pdf(blob) {
    const file = new Blob([blob], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    this.iframeEl.src = fileURL;
  }
}

angular.module('pims').service('Print', Print);
